// Task card. Used by MyTasks kanban columns.

import { Prio, CatTag } from './atoms.jsx';
import { daysUntil, fmtShort, fmtDateTime, isOverdue, overdueDays } from '../lib/dates.ts';
import { isBlocked } from '../lib/dependencies.ts';
import { DependencyHintInline } from './DependencyHint.jsx';

export const TaskCard = ({ task, allTasks, onClick }) => {
  const days = daysUntil(task.dueDate);
  const overdue = isOverdue(task);
  const blocked = allTasks ? isBlocked(task, allTasks) : false;
  const lastUpdate = task.updates && task.updates[task.updates.length - 1];
  const className = [
    'task-card',
    overdue && 'overdue',
    blocked && 'blocked'
  ].filter(Boolean).join(' ');
  return (
    <article className={className}
             onClick={onClick}
             role="button" tabIndex={0}
             onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
             aria-label={`待办：${task.title}${blocked ? ' · 被依赖阻塞' : ''}`}>
      <div className="task-card-header">
        <Prio value={task.priority} />
        <CatTag value={task.category} />
      </div>
      <h3 className="task-card-title">{task.title}</h3>
      <div className="task-card-meta">
        <span className={`due mono ${overdue ? 'overdue-text' : ''}`}>
          {task.dueDate ? (
            overdue ? `逾期 ${overdueDays(task)} 天` :
            task.status === '已完成' ? `完成 ${fmtShort(task.completedAt)}` :
            `截止 ${fmtShort(task.dueDate)}${days !== null ? ` · 还剩 ${days}d` : ''}`
          ) : '无期限'}
        </span>
        {lastUpdate && (
          <span className="mono">{fmtDateTime(lastUpdate.at).slice(0, 5)} 更新</span>
        )}
        <DependencyHintInline task={task} allTasks={allTasks || []} />
      </div>
    </article>
  );
};
